module.exports = __webpack_public_path__ + "/build/web/images/hero-about.f9f0cdefce645f151160a2ac6941bb19.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-about.jpg
// module id = 133
// module chunks = 13